import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useAreaMasterHook from './area-master.hook';
import * as styled from './area-master.styles';
import themes from './themes';

import EditableTable from '../../components/edit-table';

export interface AreaMasterProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = AreaMasterProps & ThemeOverride;

function AreaMaster(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
          dataForColumns,
          columnNames,
          handleSaveAndDeleteFromTable
        } = useAreaMasterHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.AreaMaster className={`area-master ${className ?? ''}`.trim()} style={style}>

        <EditableTable
          tableData={dataForColumns}
          tableColumns={columnNames}
          Table_Header='AREA EDITOR'
          hiddenColumns={['displayseq', 'remarks', 'isactive']}
          handleSave={handleSaveAndDeleteFromTable}
          showActions_ext = {true}
          allowSelection = {false}
          selectInputReturnType= {'value'}
          saveReturnType={'row'}
          onlyAddableFields={['areacode', 'areaname']}
        />

      </styled.AreaMaster>
    </ThemeProvider>
  );
}

export default memo(AreaMaster) as unknown as typeof AreaMaster;
